import React from "react";
import { SignIn, SignOut, Greetings } from "aws-amplify-react";
import { CustomSignIn } from "./login";
import App from "./App";
import { Authenticator } from "aws-amplify-react";
import Amplify from 'aws-amplify';
import '@aws-amplify/ui/dist/style.css';

Amplify.configure({
    Auth: {
        identityPoolId: process.env.REACT_APP_AdminIdentityPoolID,
        region: process.env.REACT_APP_Region,
        userPoolId: process.env.REACT_APP_AdminUserPoolId,
        userPoolWebClientId: process.env.REACT_APP_AdminUserPoolWebClientId,
    },
    Storage: {
        AWSS3: {
            bucket: process.env.REACT_APP_S3FrontendBucket, //REQUIRED -  Amazon S3 bucket
            region: process.env.REACT_APP_Region, //OPTIONAL -  Amazon service region
        }
    },
    API: {
        endpoints: [
            {
                name: process.env.REACT_APP_APIGatewayName,
                endpoint: process.env.REACT_APP_APIEndpoint
            },
            {
                name: process.env.REACT_APP_APIGatewayNameWHOC,
                endpoint: process.env.REACT_APP_APIEndpointWHOC
            }
        ]
    }
});

class AppWithAuth extends React.Component {
    render() {
        return (
            <div>
                <Authenticator hide={[SignIn, SignOut, Greetings]}>
                    <CustomSignIn />
                    <App />
                </Authenticator>
            </div>
        );
    }
}

export default AppWithAuth;